<script setup lang="ts">
import { ref } from 'vue'
import { DateInput, DateOnly } from '@hantera/design-system'
import { useLocalization } from '@hantera/portal-app'

const props = defineProps<{
  onGenerate?: (description: string, expiresAt: Date) => void
  onCancel?: () => void
}>()

const t = useLocalization('iam.clients')

const description = ref('')

const expirationDate = ref<DateOnly>(DateOnly.today().addMonths(12))

function handleGenerate() {
  if (expirationDate.value) {
    props.onGenerate?.(description.value, expirationDate.value.toDate())
  }
}

function handleCancel() {
  props.onCancel?.()
}
</script>

<template>
  <div class="generate-secret-dialog p2">
    <div class="form-field">
      <label>{{ t('secrets.form.description') }}</label>
      <input
        type="text"
        v-model="description"
        :placeholder="t('secrets.form.descriptionPlaceholder')"
        class="text-input"
      />
      <p class="field-help">{{ t('secrets.form.descriptionHelp') }}</p>
    </div>

    <div class="form-field">
      <label>{{ t('secrets.form.expires') }}</label>
      <DateInput
        v-model="expirationDate"
        :min-date="DateOnly.today()"
      />
      <p class="field-help">{{ t('secrets.form.expiresHelp') }}</p>
    </div>

    <div class="dialog-actions">
      <button @click="handleCancel" class="btn-secondary">
        {{ t('actions.cancel') }}
      </button>
      <button @click="handleGenerate" class="btn-primary" :disabled="!expirationDate">
        {{ t('actions.generateSecret') }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.generate-secret-dialog {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  min-width: 400px;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.text-input {
  padding: 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 1rem;
}

.text-input:focus {
  outline: none;
  border-color: var(--color-primary);
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid var(--color-border);
}
</style>
